import React, { createContext, useRef, useState } from 'react';

const ProfileContext = createContext();

const ProfileProvider = ({ children }) => {
  const [changed, setChanged] = useState(false);
  const formikHelpersRef = useRef({});

  return (
    <ProfileContext.Provider
      value={{
        changed,
        setChanged,
        formikHelpersRef,
        submitForm: formikHelpersRef.current.submitForm,
        resetForm: formikHelpersRef.current.resetForm,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};

export { ProfileContext, ProfileProvider };
